import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import { Form, Input } from "semantic-ui-react";

import HeaderCustom from "./HeaderCustom";

type InformationProps = {
  detail?: InformationDataType;
  error?: Record<string, any>;
  readOnly?: boolean;
  showAccountNameLabel?: boolean;
};

export type InformationDataType = Partial<{
  accountName: string;
  description: string;
  username: string;
}>;

const InformationFormBasic = forwardRef((props: InformationProps, ref) => {
  const [detail, setDetail] = useState<InformationDataType>({});

  useEffect(() => {
    if (props.detail) {
      setDetail(props.detail);
    }
  }, [props.detail]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      accountName: detail.accountName,
      description: detail.description,
    }),
  }));

  const handleInputChange = (field: keyof typeof detail, value: any) => {
    setDetail((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <>
      <div>
        <Form>
          <Form.Group inline>
            <Form.Field width={4}>ชื่อผู้ใช้</Form.Field>
            <Form.Field width={4}>
              <div style={{ wordSpacing: "10px" }}>{props.detail?.username}</div>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>

      <div style={{ marginTop: "45px" }}>
        <Form>
          <HeaderCustom label="ข้อมูลบัญชี" />

          <Form.Group style={{ alignItems: "baseline" }} inline>
            <Form.Field width={4}>
              <div style={{ display: "flex" }}>
                <label>ชื่อ Official Account</label>
                <div style={{ color: "red" }}>*</div>
              </div>
            </Form.Field>
            <Form.Field width={4}>
              {props.readOnly ? (
                <div>{detail.accountName}</div>
              ) : (
                <div style={{ display: "grid", width: "100%" }}>
                  <Input
                    error={props.error?.accountName}
                    value={detail.accountName}
                    onChange={(e, { value }) => handleInputChange("accountName", value)}
                  />
                  {props.error?.accountName && (
                    <label className="font-error">กรุณาระบุ Official Account</label>
                  )}
                </div>
              )}
            </Form.Field>
            {props.showAccountNameLabel && (
              <Form.Field width={8}>
                <label style={{ color: "#828282" }}>
                  *ตัวอย่างการตั้งชื่อ : แผนกอายุรกรรม โรงพยาบาลสุขภาพดี
                </label>
              </Form.Field>
            )}
          </Form.Group>
          <Form.Group style={{ marginTop: "20px" }} inline>
            <Form.Field width={4}>
              <label>รายละเอียดเพิ่มเติม</label>
            </Form.Field>
            <Form.Field width={4}>
              {props.readOnly ? (
                <div>{detail.description || "-"}</div>
              ) : (
                <Input
                  value={detail.description}
                  onChange={(e, { value }) => handleInputChange("description", value)}
                />
              )}
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    </>
  );
});

InformationFormBasic.displayName = "InformationFormBasic";

export default React.memo(InformationFormBasic);
